export default {
  props: {
    title: String,
    dataObj: Object
  }
};